<template>
    <section class="is-relative section">
        <div class="lb-question-games">
            <div v-if="questions.length" class="is-relative lb-question-container pt-6">
                <session-object-card
                    ref="questionCard"
                    :key="question._id"
                    :time-limit="0"
                    :time-units="session.configuration.timeUnits"
                    :content="question"
                    :is-simulation="session.simulation"
                    @answer="registerAnswer"
                    @timeout="registerEmptyAnswer"
                    @stopSimulation="$emit('close')"
                >
                    <nav class="level is-mobile">
                        <div class="level-left"></div>
                        <div class="level-item">
                            <progress
                                :value="progress"
                                class="progress is-primary px-3"
                                max="100"
                            >{{ progress }}%</progress>
                        </div>
                        <div class="level-right">
                            <a
                                class="button has-background-very-light-pink"
                                @click="registerEmptyAnswer"
                            >
                                <span class="icon is-medium">
                                    <i class="mdi mdi-24px mdi-chevron-right"></i>
                                </span>
                            </a>
                        </div>
                    </nav>
                </session-object-card>
                <app-animation v-if="showAnimation" :animation="animation" />
                <play-score-viewer
                    v-if="!session.simulation"
                    :score="score"
                    :ranking="rankingInfo"
                    :questions="questionsInfo"
                    class="lb-score-play"
                />
            </div>
            <session-end-resume
                v-else-if="!session.simulation"
                :score="score"
                :rightQuestions="rightQuestions"
                :failedQuestions="failedQuestions"
                :noAnswered="noAnswered"
            />
        </div>
    </section>
</template>

<script>
import SessionObjectCard from '@/components/SessionObjectCard';
import SessionEndResume from '@/components/SessionEndResume';
import AppAnimation from '@/components/AppAnimation';
import PlayScoreViewer from '@/components/PlayScoreViewer';
import { sendAnswer, getUserRankingPosition } from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        SessionObjectCard,
        AppAnimation,
        PlayScoreViewer,
        SessionEndResume,
    },
    data() {
        return {
            index: 0,
            showAnimation: false,
            animation: require('@/assets/animations/checkmark.json'),
            currentSessionAnsweredQuestions: [],
            score: 0,
            rightQuestions: 0,
            noAnswered: 0,
            rankingInfo:{
                position: 0,
                users: 0
            }
        };
    },
    computed: {
        answeredQuestions() {
            return [
                ...this.currentSessionAnsweredQuestions,
                ..._.pluck(
                    _.pluck(this.session.session_answers, 'object'),
                    '_id'
                ),
            ];
        },
        questions() {
            const remainingQuestions = _.chain(this.session.context)
                .filter((question) => {
                    return !_.contains(this.answeredQuestions, question._id);
                })
                .sort((question) => {
                    return -new Date(question.created);
                })
                .value();
            if (remainingQuestions.length == 0) {
                this.$emit('close');
            }
            return remainingQuestions;
        },

        question() {
            return this.questions[0];
        },
        session() {
            return this.$store.state.session;
        },
        progress() {
            return (
                (
                    this.answeredQuestions.length / this.session.context.length
                ).toFixed(2) * 100
            );
        },
        failedQuestions(){
            return this.session.context.length - this.rightQuestions - this.noAnswered;
        },
        questionsInfo() {
            return {
                'answered':this.answeredQuestions.length,
                'total':this.session.context.length
            }
        },
    },
    mounted() {
        if (!this.session.simulation) {
            // no need to get user score in simulated session
            getUserRankingPosition(this.session._id).then(({ data }) => {
                this.rankingInfo.users = data.totalUsers;
                this.rankingInfo.position = data.totalUsers;
                this.score = data.score;
            });
        }
    },
    methods: {
        registerEmptyAnswer() {
            this.registerAnswer({
                answer: {
                    answer: { value: '' },
                    object: this.question._id,
                    time: 0,
                    points: 0,
                },
            });
            this.noAnswered++;
        },
        async registerAnswer({ answer }) {
            //this.$emit("answer", answer);
            this.showAnimation = true;
            if (answer.points > 0) {
                this.animation = require('@/assets/animations/checkmark.json');
                this.rightQuestions++;
            } else {
                this.animation = require('@/assets/animations/error.json');
            }
            setTimeout(() => {
                this.showAnimation = false;
                this.currentSessionAnsweredQuestions.push(answer.object);
            }, 2000);

            if (this.session.simulation) {
                return;
            }

            await sendAnswer(this.$store.state.session._id, {
                ...answer,
                project: this.$store.state.session.project,
            });
            let position = await getUserRankingPosition(this.session._id);
            this.rankingInfo.users = position.data.totalUsers;
            this.rankingInfo.position = position.data.totalUsers;
            this.score = position.data.score;
        },
    },
};
</script>

<style scoped>
.lb-question-game {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
}
.lb-score-play {
    position: absolute !important;
    margin: auto;
    top: 0%;
    left: 0;
    right: 0;
}
.progress {
    border-radius: 0;
    height: 0.4rem;
}
</style>
